<div class="text-center py-3" *ngIf="matter_associations_loading">
  <i class="fas fa-spinner fa-pulse fa-2x"></i>
</div>
<div *ngIf="!matter_associations_loading">
  <table class="table">
    <tbody>
      <tr *ngIf="matterAssociations.is_root === false">
        <th colspan="3" class="text-center" scope="row">
          Ancestors -&nbsp;
          <app-badge badgeType="primary">{{ matterAssociations.ancestors.length }}</app-badge>
        </th>
      </tr>
      <tr *ngFor="let ancestor of matterAssociations.ancestors">
        <td>
          <a [routerLink]="'/matters/' + ancestor.id">{{ ancestor.number }}</a>
        </td>
        <td>{{ ancestor.name }}</td>
        <td><span class="red" *ngIf="ancestor.is_perm">Perm</span></td>
      </tr>
      <tr *ngIf="!matterAssociations.is_root && matterAssociations.has_siblings">
        <th colspan="3" class="text-center" scope="row">
          Siblings -&nbsp;
          <app-badge badgeType="primary">{{ matterAssociations.siblings.length }}</app-badge>
        </th>
      </tr>
      <tr *ngFor="let sibling of matterAssociations.siblings">
        <td>
          <a [routerLink]="'/matters/' + sibling.id">{{ sibling.number }}</a>
        </td>
        <td>{{ sibling.name }}</td>
        <td><span class="red" *ngIf="sibling.is_perm">Perm</span></td>
      </tr>
      <tr *ngIf="matterAssociations.has_children">
        <th colspan="3" class="text-center" scope="row">
          Descendants -&nbsp;
          <app-badge badgeType="primary">{{ matterAssociations.descendants.length }}</app-badge>
        </th>
      </tr>
      <tr *ngFor="let descendant of matterAssociations.descendants">
        <td>
          <a [routerLink]="'/matters/' + descendant.id">{{ descendant.number }}</a>
        </td>
        <td>{{ descendant.name }}</td>
        <td><span class="red" *ngIf="descendant.is_perm">Perm</span></td>
      </tr>
    </tbody>
  </table>
</div>
